import { PaginationProps } from '@mui/material';
import { Pagination, PaginationItem } from '@mui/material';

import { Icon } from 'components';
import { Button } from 'components/button';

export const CustomPagination = (props: PaginationProps) => {
  return (
    <Pagination
      {...props}
      classes={{
        ...props.classes,
        ul: 'flex items-center justify-center gap-2',
      }}
      renderItem={(item) => {
        if (item.type === 'previous' || item.type === 'next') {
          return (
            <Button
              hasMinWidth
              variant="text"
              onClick={item.onClick}
              disabled={item.disabled}
              buttonClassName="h-5 w-5 p-0 mx-2 cursor-pointer"
            >
              {item.type === 'previous' ? (
                <Icon.ChevronLeft />
              ) : (
                <Icon.ChevronRight />
              )}
            </Button>
          );
        }

        if (item.type === 'page') {
          return (
            <Button
              hasMinWidth
              className="h-12 w-12"
              onClick={item.onClick}
              buttonClassName="h-full w-full p-0"
              variant={item.selected ? 'outlined' : 'text'}
            >
              {item.page}
            </Button>
          );
        }

        return <PaginationItem {...item} />;
      }}
    />
  );
};
